import { NotificationLogsDashboard } from "@/components/notification-logs/notification-logs-dashboard";
import { trpc } from "@/lib/trpc";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/projects/$projectSlug/_layout/logs")({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  const { data: projectId } = useSuspenseQuery(
    trpc.projects.getBySlug.queryOptions(params, { select: (data) => data.id }),
  );

  return (
    <div className="space-y-6">
      <NotificationLogsDashboard projectId={projectId} />
    </div>
  );
}
